// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> american-landmark-preferred -> cavalli-at-iron-horse-station-7953
// Generated: 2026-11-03T20:37:41.189Z
// Counts: 2 design, 82 content, 37 slot group, 3 collection binding, 8 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_icon"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "betterbot-chatbot.embed_script": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_betterbot_script"
  },
  "hyperlocal-links.show_header": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "hyperlocal-links.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "petpolicy.stat_pet_fee_sublabel": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pets_blurb"
  },
  "scheduleatour.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "scheduleatour.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_thankyou_blurb"
  },
  "accessibilityhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At Cavalli at Iron Horse Station, we're committed to making our community welcoming to everyone—online and in person. We continually work to ensure this website is accessible and easy to navigate for all visitors, regardless of ability.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>From a resort-style pool with cabanas and BBQ spaces to a strength and cardio studio, yoga/flex studio, game room, and WiFi-equipped resident lounge, Cavalli pairs room to unwind with everyday conveniences like package lockers, EV charging, and controlled-access entry. Inside, thoughtfully finished homes bring it all together with stainless steel appliances, wood-style flooring, tall ceilings, and in-home washer and dryer options.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Your new home at Cavalli at Iron Horse Station is just an application away.</strong> Apply online today and settle into a polished studio to three-bedroom apartment with elevated finishes, resort-style amenities, and easy access to the best of North Richland Hills.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Ready to see it for yourself?</strong> Reach out to the Cavalli at Iron Horse Station team for directions, availability, and a closer look at our modern studio, one-, two-, and three-bedroom homes. We're here to answer your questions and help you settle into polished apartment living in North Richland Hills.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "favoriteplaces.body": {
    "overrideType": "VALUE",
    "customValue": "<p>We love calling North Richland Hills home, and we think you will too. Explore our handpicked local favorites—from homestyle Texas cooking to the Iron Horse district's parks and trails—to find your new go-to spots.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>From efficient 605-square-foot studios to spacious three-bedroom homes topping 1,298 square feet, Cavalli at Iron Horse Station offers studio, one-, two-, and three-bedroom layouts to match the way you live in North Richland Hills. Browse current pricing and availability below to find the plan—and finishes like wood-style flooring, stainless appliances, and in-home washer and dryer options—that fits your day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Scroll through light-filled Cavalli apartments—wood-style flooring, tall ceilings, and kitchens dressed in gray cabinetry, granite counters, and stainless steel appliances—alongside spa-style baths with double vanities and walk-in closets. Then step into the community: a resort-style pool with cabanas, a texture-rich resident lounge, a game room with shuffleboard and foosball, and a bright fitness studio overlooking the water.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>From Cavalli at Iron Horse Station, North Richland Hills unfolds with a TEXRail stop for easy rides toward Fort Worth, Grapevine, and DFW Airport, plus homestyle favorites like Babe's Chicken Dinner House and craft barbecue at Barrel & Bones just minutes away. Tee off at the namesake Iron Horse Golf Course, cool off at NRH2O Family Water Park, or stroll the trails at The Lakes at HomeTown—then schedule a tour to feel how connected this address really is.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At Cavalli at Iron Horse Station, your furry companions are part of the family—with an on-site bark park, a pampering pet spa, and select homes featuring private fenced yards. Explore our pet policy below and see just how at home your pets will feel.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At Cavalli at Iron Horse Station, safeguarding your personal information is part of the polished, worry-free experience we promise. Here's how we collect, use, and protect the details you share with our community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "promopopup.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f237f-68c0-7401-acc6-7fbc5ebac84d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccesshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Your Resident Portal at Cavalli at Iron Horse Station.</strong><br>Log in anytime to pay rent, submit and track maintenance requests, and stay on top of community updates and package notifications. It's the easy, 24/7 way to manage your account—so you can spend less time on the details and more time enjoying polished apartment living in North Richland Hills.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Hear it from the people who live here.</strong> Residents of Cavalli at Iron Horse Station describe a clean, well-kept community with a personable, accommodating team that stays on top of questions and maintenance—and tour visitors who call the amenities “spectacular.” Read the reviews below to see what living here is really like.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Walk the modern studio to three-bedroom homes, take in the stainless kitchens and wood-style floors, and unwind by the resort-style pool, resident lounge, and fitness studios—Cavalli at Iron Horse Station makes it easy to picture life in North Richland Hills. Book an in-person or virtual tour today and see your next home for yourself.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse floor plans, amenities, the neighborhood, and more—everything you need to get to know Cavalli at Iron Horse Station is just a click away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Thank you for reaching out—we've received your inquiry.</strong> The Cavalli at Iron Horse Station leasing team will follow up with you soon, so you can start picturing polished apartment living with modern layouts, elevated finishes, and everyday North Richland Hills convenience close at hand.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside the Cavalli at Iron Horse Station Community Tour for a first look at the modern finishes, resort-style pool, and inviting shared spaces that shape everyday life here in North Richland Hills. Take a virtual walk through the community, then picture how your next home comes together—no appointment required.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.nav_col2_link2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/leadership"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/careers"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://icx.efrontcloud.com/@4157/americanlandmarkfund/login.aspx"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/news"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Contact us"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.utility_link_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "scheduleatourcallout.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "custom_self_guided_tour_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenitieshomesection.amenity_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment building with an outdoor swimming pool and lounge chairs."
      },
      "amenity_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-3d9b-7778-8e51-643616f9f9a0.webp"
      },
      "amenity_image_alt_text": {
        "type": "VALUE",
        "customValue": "Resort-style outdoor pool with lounge chairs and a seating area with a fire pit."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Style Pool"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-2741-734a-9bdd-61d690cdeed1.webp"
      }
    }
  },
  "amenitieshomesection.amenity_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with treadmills, ellipticals, and a stationary bike."
      },
      "amenity_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8984-f2e0-7222-8b58-349e0b8e5057.webp"
      },
      "amenity_image_alt_text": {
        "type": "VALUE",
        "customValue": "Gym with cardio equipment: elliptical machines, stationary bikes, and treadmills."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Strength & Cardio Studio"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019d02f3-369c-701b-80f2-5023e017119d.webp"
      }
    }
  },
  "amenitieshomesection.amenity_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "An outdoor dog park with artificial turf, a playground structure, and a waste station."
      },
      "amenity_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5737427910000640/019d02f3-ab10-776e-b271-7b8bc34a35cd.webp"
      },
      "amenity_image_alt_text": {
        "type": "VALUE",
        "customValue": "An outdoor dog park with artificial turf, a playground structure, and a waste station."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Dog Park & Pet Spa"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019d02f3-ab10-776e-b271-7b8bc34a35cd.webp"
      }
    }
  },
  "amenitieshomesection.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style outdoor pool with lounge chairs and a seating area with a fire pit."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Style Pool"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-3d9b-7778-8e51-643616f9f9a0.webp"
      }
    }
  },
  "amenitieshomesection.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with cardio equipment: elliptical machines, stationary bikes, and treadmills."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Strength & Cardio Studio"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8984-f2e0-7222-8b58-349e0b8e5057.webp"
      }
    }
  },
  "amenitieshomesection.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy lounge area with plush seating, bookshelves, and a coffee table."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resident Lounge"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-310a-7048-b5a5-97cdd6ce0cc3.webp"
      }
    }
  },
  "amenitieslist.featured": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and cabanas in front of apartment buildings."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Style Swimming Pool"
      },
      "eyebrow": {
        "type": "VALUE",
        "customValue": "Featured Amenity"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5737427910000640/019d02f4-1ca8-7625-bad6-658fbc936140.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "<p>Cavalli's resort-style swimming pool is the heart of the community, framed by comfortable lounge chairs, shaded cabanas, and fire pit seating. It's the perfect place to cool off on a warm North Richland Hills afternoon or gather with neighbors as the sun goes down. With BBQ and picnic areas just steps away, it's an easy go-to for both quiet recharging and weekend get-togethers.</p>"
      }
    }
  },
  "amenitieslist.in_home_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5737427910000640/019d02f3-2b4b-725e-b44b-8da6e47b92b2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen and living area with stainless steel appliances, granite countertops, island with bar stools, and a sofa."
      }
    }
  },
  "favoriteplaces.place_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150d-74a3-748d-9759-8e290e558478.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Babe's Chicken Dinner House"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Babe's Chicken Dinner House"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://babeschicken.com/?y_source=1_MjAyMjkwMzQ0Mi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D"
      }
    }
  },
  "favoriteplaces.place_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150f-7f3b-713e-aae6-03f83f9c0d17.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Barrel & Bones Craft Bar and Smokehouse"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Barrel & Bones Craft Bar and Smokehouse"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://orders.barrelandbones.com/"
      }
    }
  },
  "favoriteplaces.place_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019f150e-0aed-735a-9f48-ddb7e100470c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Iron Horse Golf Course"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Iron Horse Golf Course"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://www.ironhorsetx.com/"
      }
    }
  },
  "homefeaturessplit.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-39ff-75e9-8998-8d99e529762f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern communal kitchen island with seating and decorative sliding doors."
      }
    }
  },
  "homegallerygrid.gallery_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-2c74-73bf-ac9f-4eb91851ccf5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with light gray cabinets, granite countertops, stainless steel appliances, and a kitchen island."
      }
    }
  },
  "homegallerygrid.gallery_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-27ac-7464-b46d-c88034f72eaa.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bedroom with a queen-size bed and view into the en-suite bathroom."
      }
    }
  },
  "homegallerygrid.gallery_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-06c3-767d-9ab6-fec64341b449.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community lounge with shuffleboard, foosball table, and comfortable seating."
      }
    }
  },
  "homeintrosection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-2241-73b1-b2b0-51c15e943365.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a brown leather sofa, armchair, and a modern kitchen in the background."
      }
    }
  },
  "interiorintro.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5737427910000640/019d47d9-aac6-70f3-9316-1b69530b1c34.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright, open-concept living room and modern kitchen in a Cavalli at Iron Horse Station apartment, with a private balcony view beyond."
      }
    }
  },
  "neighborhoodctahomesection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5737427910000640/019d02f3-9f13-7505-bf4f-59927534d8da.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a resort-style swimming pool with lounge chairs and outdoor seating."
      }
    }
  },
  "neighborhoodhomesection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-2446-74c8-b3e4-7d84061a4ca9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a modern apartment building with a dark facade, stone accents, and balconies under a cloudy blue sky."
      }
    }
  },
  "pageblurb.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5737427910000640/019d02f4-1ca8-7625-bad6-658fbc936140.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with cabanas and lounge chairs in front of the Cavalli at Iron Horse Station apartment buildings."
      }
    }
  },
  "pageblurb.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-2c74-73bf-ac9f-4eb91851ccf5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment kitchen with light gray cabinetry, granite countertops, stainless steel appliances, and a center island."
      }
    }
  },
  "pageblurb.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5737427910000640/019d47d9-6606-7598-b839-4ac9a98f667e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Signature metal horse sculptures at the Cavalli at Iron Horse Station entrance, framed by modern apartment buildings."
      }
    }
  },
  "residentaccess.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-2446-74c8-b3e4-7d84061a4ca9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a modern apartment building with a dark facade, stone accents, and balconies under a cloudy blue sky."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Make a Payment"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://cavalli.loftliving.com/login"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "residentaccess.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-2241-73b1-b2b0-51c15e943365.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a brown leather sofa, armchair, and a modern kitchen in the background."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resident Portal"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://cavalli.loftliving.com/login"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "residentaccess.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e8985-3d9b-7778-8e51-643616f9f9a0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style outdoor pool with lounge chairs and a seating area with a fire pit."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Contact Us"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/contact"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "betterbot-chatbot",
      "blockId": "betterbot-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    },
    {
      "sectionId": "leasing-ai-pixel",
      "blockId": "leasing-ai-pixel",
      "position": 0
    }
  ],
  "home": [
    {
      "sectionId": "hyperlocal-links",
      "blockId": "hyperlocal-links",
      "position": 17
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "neighborhoodmap.category_order": {
    "properties": {
      "textAlign": "center"
    }
  }
};
